module.exports = __webpack_public_path__ + "img/bg.ec8d9598.png";